import React from "react";
// import { Link } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Container } from "react-bootstrap";
import notFound from "../Components/Assets/Images/notFound.jpg";
import WestIcon from "@mui/icons-material/West";

const NotFound = () => {
  return (
    <React.Fragment>
      <Box>
        <Container className="container404">
          <Box className="404Img">
            <Box
              component="img"
              src={notFound}
              alt="404 Not Found"
              sx={{ width: "100%", height: "auto" }}
            />
          </Box>
          <Stack direction="row" justifyContent="center">
            <Button
              component={RouterLink}
              to="/"
              variant="contained"
              color="primary"
              size="large"
              startIcon={<WestIcon />}
              className="goBackBtn"
            >
              Back to Home page
            </Button>
          </Stack>
        </Container>
      </Box>
    </React.Fragment>
  );
};

export default NotFound;
